"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var DEFAULT_PROPS = {
  resourceType: 'Header350_1_0_0',
  mainHeading: '',
  textAlignment: 'center',
  paragraph: '',
  theme: 'light',
  link: {}
};
var _default = exports["default"] = DEFAULT_PROPS;